export const ICON_COLORS = {
  accentBlue: 'text-icon-accent-blue',
  accentGreen: 'text-icon-accent-green',
  accentOrange: 'text-icon-accent-orange',
  accentPurple: 'text-icon-accent-purple',
  accentRed: 'text-icon-accent-red',
  bold: 'text-icon-bold',
  brand: 'text-icon-brand',
  danger: 'text-icon-danger',
  disabled: 'text-icon-disabled',
  info: 'text-icon-info',
  inverse: 'text-icon-inverse',
  inverseSubtle: 'text-icon-inverse-subtle',
  inverseSubtleActive: 'text-icon-inverse-subtle-active',
  inverseSubtleHover: 'text-icon-inverse-subtle-hover',
  link: 'text-icon-link',
  linkActive: 'text-icon-link-active',
  linkHover: 'text-icon-link-hover',
  logoBlack: 'text-light-charcoal-950',
  logoBlue: 'text-light-brand-500',
  logoWhite: 'text-white',
  subtle: 'text-icon-subtle',
  subtleActive: 'text-icon-subtle-active',
  subtleHover: 'text-icon-subtle-hover',
  success: 'text-icon-success',
  warning: 'text-icon-warning',
} as const;

export type IconName = keyof typeof ICONS;

export const ICONS = {
  add: 'material-symbols:add-2-rounded',
  amazon: 'payment/amazon',
  android: 'uil:android',
  apple: 'ri:apple-fill',
  architecture: 'custom/architecture',
  arrowBack: 'material-symbols:arrow-back-rounded',
  arrowDown: 'material-symbols:arrow-downward-rounded',
  arrowForward: 'material-symbols:arrow-forward-rounded',
  arrowRight: 'material-symbols:arrow-right-alt-rounded',
  arrowUp: 'material-symbols:arrow-upward-rounded',
  artTrack: 'material-symbols:art-track-outline-rounded',
  attachFile: 'material-symbols:attach-file-rounded',
  behance: 'icon-park-outline:dribble',
  bitcoin: 'payment/bitcoin',
  blurbLogo: 'custom/blurb-logo',
  bold: 'material-symbols:format-bold-rounded',
  book: 'custom/book',
  business: 'custom/business',
  calendarDateRange: 'mdi:calendar-range-outline',
  calendarToday: 'material-symbols:today-outline-rounded',
  cancel: 'material-symbols:cancel-rounded',
  cart: 'material-symbols:shopping-cart-rounded',
  check: 'material-symbols:check-rounded',
  chevronDown: 'material-symbols:keyboard-arrow-down-rounded',
  chevronLeft: 'material-symbols:chevron-left-rounded',
  chevronRight: 'material-symbols:chevron-right-rounded',
  chevronUp: 'material-symbols:keyboard-arrow-up-rounded',
  close: 'material-symbols:close-rounded',
  contentCopy: 'material-symbols:content-copy-outline-rounded',
  delete: 'material-symbols:delete-outline-rounded',
  document: 'material-symbols:docs-outline-rounded',
  done: 'material-symbols:check-circle-outline-rounded',
  download: 'material-symbols:download-rounded',
  dribbble: 'icon-park-outline:dribble',
  dropbox: 'icomoon-free:dropbox',
  edit: 'mdi:pencil-outline',
  email: 'mdi:email-outline',
  error: 'material-symbols:error-outline-rounded',
  exit: 'mingcute:exit-line',
  facebook: 'ri:facebook-fill',
  filterList: 'mdi:mixer-settings',
  folder: 'material-symbols:folder-outline-rounded',
  formatAlignCenter: 'material-symbols:format-align-center-rounded',
  formatAlignJustify: 'material-symbols:format-align-justify-rounded',
  formatAlignLeft: 'material-symbols:format-align-left-rounded',
  formatAlignRight: 'material-symbols:format-align-right-rounded',
  formatBulletedList: 'material-symbols:format-list-bulleted-rounded',
  formatClear: 'material-symbols:format-clear-rounded',
  formatColor: 'material-symbols:format-color-text-rounded',
  fullscreen: 'material-symbols:fullscreen-rounded',
  github: 'ri:github-fill',
  globe: 'custom/globe',
  google: 'ri:google-fill',
  gridGuides: 'material-symbols:grid-guides',
  heartEmpty: 'material-symbols:favorite-outline-rounded',
  heartFull: 'material-symbols:favorite-rounded',
  help: 'material-symbols:help-outline-rounded',
  holidayShipping: 'custom/holiday-shipping',
  home: 'mdi:home-outline',
  image: 'material-symbols:image-outline-rounded',
  importContacts: 'material-symbols:import-contacts-outline-rounded',
  info: 'material-symbols:info-outline-rounded',
  instagram: 'mdi:instagram',
  italic: 'material-symbols:format-italic-rounded',
  landscape: 'material-symbols:crop-3-2-outline',
  leaf: 'custom/leaf',
  link: 'material-symbols:link-rounded',
  linkedin: 'ri:linkedin-box-fill',
  loading: 'line-md:loading-twotone-loop',
  locked: 'material-symbols:lock-outline',
  mastercard: 'payment/mastercard',
  menu: 'material-symbols:menu-rounded',
  menuOpen: 'material-symbols:menu-open-rounded',
  money: 'material-symbols:attach-money-rounded',
  more: 'material-symbols:more-vert',
  notification: 'material-symbols:notifications-outline-rounded',
  notificationActive: 'material-symbols:notifications-active-outline-sharp',
  notificationOff: 'material-symbols:notifications-off-outline-rounded',
  openInNew: 'material-symbols:open-in-new-rounded',
  pause: 'material-symbols:pause-circle-outline-rounded',
  payment: 'mdi:payment',
  paypal: 'ri:paypal-fill',
  person: 'material-symbols:person-outline-rounded',
  pinterest: 'ri:pinterest-fill',
  place: 'mdi:place',
  placeholder: 'material-symbols:rotate-90-degrees-ccw-outline-rounded',
  play: 'material-symbols:play-circle-outline-rounded',
  portrait: 'material-symbols:crop-portrait-outline',
  progress: 'material-symbols:progress-activity',
  reddit: 'streamline-logos:reddit-logo-solid',
  refresh: 'material-symbols:refresh-rounded',
  remove: 'material-symbols:remove-rounded',
  reply: 'mdi:reply',
  save: 'material-symbols:save-rounded',
  search: 'material-symbols:search-rounded',
  send: 'ic:round-send',
  settings: 'material-symbols:settings-rounded',
  share: 'material-symbols:share-outline',
  shiningStar: 'custom/shining-star',
  shopify: 'jam:shopify',
  slack: 'custom/slack',
  sort: 'material-symbols:sort-rounded',
  square: 'material-symbols:square-outline-rounded',
  star: 'material-symbols:star-rounded',
  starBurst: 'custom/star-burst',
  starHalf: 'material-symbols:star-half-rounded',
  starOutline: 'material-symbols:star-outline-rounded',
  straighten: 'material-symbols:straighten-outline-rounded',
  thumbDown: 'material-symbols:thumb-down-outline-rounded',
  thumbUp: 'material-symbols:thumb-up-outline-rounded',
  twitter: 'ri:twitter-fill',
  unlocked: 'material-symbols:lock-open-outline-rounded',
  upload: 'material-symbols:upload-rounded',
  visa: 'payment/visa',
  visibility: 'material-symbols:visibility-outline-rounded',
  visibilityOff: 'material-symbols:visibility-off-outline-rounded',
  volumeOff: 'material-symbols:volume-off-outline-rounded',
  volumeOn: 'material-symbols:volume-up-outline-rounded',
  warning: 'material-symbols:warning-outline-rounded',
  windows: 'ri:windows-fill',
  youtube: 'ri:youtube-fill',
} as const;
